import { Component, OnInit } from "@angular/core";
import { AuthserviceService } from "../../httpservice/authservice.service";
import { Router } from "@angular/router";
import { Storage } from "@ionic/storage";
import { BehaviorSubject } from "rxjs";
import {
  LoadingController,
  NavController,
  AlertController,
} from "@ionic/angular";
import { AppService } from "../../services/app.service";
import { ApiserviceService } from "../../httpservice/apiservice.service";
import { errMsg } from "src/app/text_control/error-msg";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { STORAGE } from "../../constant/storages";
import jwt_decode from "jwt-decode";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  form: any = { username: "", password: "" };
  authSubject = new BehaviorSubject(false);
  needsFocus: boolean;
  passwordType: string = "password";
  passwordIcon: string = "eye-off";

  apiUrl = "http://172.16.10.130:3000";

  tagVersion: string = "";

  constructor(
    public httpservice: AuthserviceService,
    public router: Router,
    private storage: Storage,
    public loadingController: LoadingController,
    public navCtrl: NavController,
    public appService: AppService,
    public apiservice: ApiserviceService,
    public alertController: AlertController
  ) {}

  ngOnInit() {
    this.tagVersion = this.appService.versionString;
    const getAccess = _getStorage(STORAGE.ACCESS_TOKEN);
    if (getAccess) {
      this.router.navigate(["/tax-invoice"]);
    }
  }
  ionViewDidEnter() {
    this.checkToken();
  }

  checkToken() {
    const bearer = _getStorage(STORAGE.B2C_TOKEN);
    if (bearer) {

      console.log('STORAGE.B2C_TOKEN=======:: ',bearer)
      this.submitlogin(bearer);
    } else {
      this.loginAD2();
    }
  }

  loginAD2() {
    const url = this.apiservice.B2C_authority;
    window.location.replace(url);
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === "text" ? "password" : "text";
    this.passwordIcon = this.passwordIcon === "eye-off" ? "eye" : "eye-off";
  }

  urlLogin = "https://uat-api.central.co.th/";
  loading: any;

  submitlogin(token: any) {
    let URL = environment.get_permissions

    try {
      this.httpservice.loginGetToken(URL, token).then(async (res: any) => {
        console.log('loginGetToken====: ',res)
        if (res.token) {
          let modules_config;
          let sub_modules;
          let token = res.token ? res.token : "access_token";
          const decoded: any = jwt_decode(res["token"]);
          console.log("============ res.token =============", res["token"]);
          console.log("============ RES LOGIN AD2 =============", decoded);
          _setStorage(STORAGE.PERMISSION_TOKEN, res["token"]);
  

          if (decoded) {
            let modules = decoded.payload.permission[0].attr[0].module;
            let userID = String(decoded.payload.user.uname).split("@")[0];
            let userBu = decoded.payload.user.bu == 'RBS' ? 'CDS' : decoded.payload.user.bu;
            let userLoc = decoded.payload.user.loc;
            let userRole = decoded.payload.permission[0]["rolec"];

            console.log("====userID======", userID);
            console.log("====userBu======", userBu);
            console.log("====userLoc======", userLoc);
            console.log("====userRole======", userRole);


            for (const item of modules) {
              if (item.code === "ETAXCONFIG") {
                modules_config = {
                  ETAXCONFIGURATION: JSON.parse(item.custom.ETAXCONFIGURATION) || false,
                  ETAXCREDITNOTE: JSON.parse(item.custom.ETAXCREDITNOTE) || false,
                  ETAXFULLTAX: JSON.parse(item.custom.ETAXFULLTAX) || false,
                  ETAXFULLTAXNOTAXID: JSON.parse(item.custom.ETAXFULLTAXNOTAXID) || false,
                  ETAXINQUIRY: JSON.parse(item.custom.ETAXINQUIRY) || false,
                  ETAXREPLACE: JSON.parse(item.custom.ETAXREPLACE) || false,
                  ETAXREPORT: JSON.parse(item.custom.ETAXREPORT) || false,
                  ETAXRESEND: JSON.parse(item.custom.ETAXRESEND) || false,
                  ETAXSUBCONFIG: {},
                };
              }
              if (item.code === "ETAXSUBCONFIG") {
                sub_modules = {
                  SUB_CONFIGSETUP: JSON.parse(item.custom.SUB_CONFIGSETUP) || false,
                  SUB_CUSTOMER: JSON.parse(item.custom.SUB_CUSTOMER) || false, 
                  SUB_ROLESETUP: JSON.parse(item.custom.SUB_ROLESETUP) || false,
                  SUB_SELLER: JSON.parse(item.custom.SUB_SELLER) || false,
                };
              }
            }
            modules_config["ETAXSUBCONFIG"] = sub_modules;

            console.log("modules_config====: ", modules_config);
            _setStorage(STORAGE.modules, modules_config);
            _setStorage(STORAGE.ActiveConfig, true);
            _setStorage(STORAGE.DATA_CARDID, "1");
            _setStorage("nameNo", "tax");
            _setStorage(STORAGE.ACCESS_TOKEN, token);
            _setStorage(STORAGE.userID, userID);
            _setStorage(STORAGE.userBu, userBu);
            _setStorage(STORAGE.userLoc, userLoc);
            _setStorage(STORAGE.userRole, userRole);

            let get_keyCardID = await _getStorage(STORAGE.DATA_KEY_CARDID);

            console.log("get_keyCardID===: ", get_keyCardID);
            let req = [
              {
                bu: userBu,
                userid: userID,
                loc: userLoc,
                keyCard: "0",
              },
            ];
            if (get_keyCardID !== null && get_keyCardID !== undefined) {
              const filter_cardid = get_keyCardID.filter(
                (f) =>
                  f.bu === userBu && f.userid === userID && f.loc === userLoc
              );
              if (filter_cardid.length > 0) {
                _setStorage(STORAGE.DATA_CARDID, filter_cardid[0].keyCard);

                this.appService.setCardEvent(filter_cardid[0].keyCard);
                this.router.navigate(["/home"]);
                this.authSubject.next(true);
              } else {
                let groupCardID = [];
                groupCardID.push(...get_keyCardID, ...req);
                _setStorage(STORAGE.DATA_KEY_CARDID, groupCardID);
                _setStorage(STORAGE.DATA_CARDID, "0");
                this.appService.setCardEvent("0");
                this.router.navigate(["/home"]);
                this.authSubject.next(true);
              }
            } else {
              _setStorage(STORAGE.DATA_CARDID, "0");
              this.appService.setCardEvent("0");
              _setStorage(STORAGE.DATA_KEY_CARDID, req);
              this.router.navigate(["/home"]);
              this.authSubject.next(true);
            }
          } else {
            this.ErrorMsg(res.statusMessage);
          }
        } else {
          this.loginAD2();
        }
      });
    } catch (error) {}
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
